<template>
    <customModal 
        :containersm="true"
        :footerShow="true"
        @closeModal="closeModal()"
    >
        <template #title>
          Site Summary
        </template>
        <template #body>
             <div class="table-responsive mt-2 scrollable">
                <table class="table table-bordered table-sm" v-if="data.length > 0">
                    <thead>
                        <tr>
                            <th>Site Code</th>
                            <th>Review Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="site in data" :key="site.id">
                            <td>{{ site.siteCode }}</td>
                            <td>{{ filter(site.runDate) }}</td>
                        </tr>
                    </tbody>
                </table>
                <div v-else class="text-center py-3">
                     No data found 
                </div>
             </div>
        </template>
    </customModal>
</template>

<script src="./DataSIgnalSiteSummaryPopup.js"></script>

<style scoped>

</style>